class AmapOptions {
  public plugins = [{
    pName: 'ToolBar',
  }];
  public center: number[] = [106.034986, 36.797026];
  public zoom: number = 5;
  public markers: any[] = [];
  public searchOption = {
    citylimit: false,
  };

  // public onSearchResult = (pois: any) => {
  //   let latSum = 0;
  //   let lngSum = 0;
  //   if (pois.length > 0) {
  //     pois.forEach((poi: any) => {
  //       const {lng, lat} = poi;
  //       lngSum += lng;
  //       latSum += lat;
  //       this.markers.push({position: [poi.lng, poi.lat], name: poi.name, address: poi.address});
  //     });
  //     const center = {
  //       lng: lngSum / pois.length,
  //       lat: latSum / pois.length,
  //     };
  //     this.center = [center.lng, center.lat];
  //   }
  // }

}

export const amapOptions = new AmapOptions();
